import { defineStore } from 'pinia';

interface AppStoreState {
  loading: boolean;
  validating: boolean;
  donationsLoading: boolean;
}

export const useAppStore = defineStore('app', {
  state: (): AppStoreState => {
    return {
      loading: false,
      validating: false,
      donationsLoading: false,
    } as AppStoreState;
  },
  getters: {
    isLoading: (state) => state.loading,
    isValidating: (state) => state.validating,
    isDonationsLoading: (state) => state.donationsLoading,
  },
  actions: {
    setLoading() {
      this.loading = true;
    },
    setValidating() {
      this.validating = true;
    },
    setDonationsLoading() {
      this.donationsLoading = true;
    }
  },
});
